import { useCalendarMatrix } from "../hooks/useCalendarMatrix";
import useStore from "../hooks/useStore";
import { useAllWebinars } from "../hooks/useWebinars";
import Month from "./Month";
import Spinner from "./Spinner";

const Calendar = () => {
  const { webinars } = useAllWebinars();
  const month = useStore((state) => state.selectedMonth);
  const year = useStore((state) => state.selectedYear);
  const calendarMatrix = useCalendarMatrix(month.value, year.value);
  const isLoading = !webinars || webinars.length === 0;

  return (
    <>
      {isLoading ? (
        <div className="tw-bg-white tw-min-h-[450px] tw-flex tw-flex-col tw-items-center tw-justify-center">
          <Spinner />
          <span className="tw-text-tr-date tw-text-lg tw-text-center tw-mt-6">
            Loading...
          </span>
        </div>
      ) : (
        <div className="custom-container-tr tw-pt-10 tw-pb-20">
          <div className="tw-flex tw-flex-col tw-bg-[#fafafa] ">
            <div className="tw-flex-1 tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 md:tw-grid-cols-4 lg:tw-grid-cols-5 xl:tw-grid-cols-7 tw-grid-rows-auto">
              {calendarMatrix.map((days, idx) => (
                <Month key={idx} days={days} />
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Calendar;
